import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`app ${document.body.classList.contains('dark-theme') ? 'dark-theme' : ''}`}>
      <div className="app-container">
        <div className="nes-container is-rounded with-title">
          <p className="title">About BreakMe.ai</p>
          
          {/* Navigation */}
          <div className="page-navigation">
            <Link to="/" className="nes-btn is-primary">← Home</Link>
            <div className="nav-buttons">
              <Link to="/tokenomics" className="nes-btn">Tokenomics</Link>
              <Link to="/updates" className="nes-btn">Updates</Link>
            </div>
          </div>

          {/* Content */}
          <div className="content-section">
            <h2>Transparent Mechanics</h2>
            <p>The game leverages the <strong>Solana blockchain</strong>, empowering the AI agent with on-chain tools and round bounty funds. All transactions are <em>publicly visible</em> via blockchain explorers, and players' textual-prompt attempts are displayed in real-time on the Breakme.ai website.</p>

            <h2>Dynamic Pricing</h2>
            <p>Players purchase attempts to break the AI agent's defenses, with pricing adjusting dynamically during each round. The pricing model follows <em>predefined rules</em> to ensure fairness and competitiveness.</p>

            <h2>Attempt-Fee Routing</h2>
            <p>The majority of attempt fees flow directly to the <strong>round bounty wallet</strong>. A portion is allocated to the adjustment wallet, while another percentage is reserved for development fees. These allocations are determined on a <em>round-by-round basis</em>.</p>

            <h2>Gamified Penetration Testing</h2>
            <p>Breakme.ai serves as a <strong>crowdsourced testing ground</strong> for improving the robustness of AI models against hacky/jailbreak prompt attacks.</p>

            <h2>Pay to Attempt</h2>
            <p>Players use <strong>Solana (SOL)</strong> to purchase 3 attempts per transaction. The price for each 3-attempt bundle changes globally for all players, following a predefined pricing curve for the round. The dynamic pricing model operates in four modes:</p>
            <ul>
              <li><em>Threshold-Based:</em> Fixed price up to a certain number of attempts</li>
              <li><em>Factor Increase:</em> Price grows by a predetermined multiplier with each purchased attempt bundle</li>
              <li><em>Hybrid Model:</em> Combines elements of threshold and linear pricing</li>
              <li><em>Demand-Based:</em> Adjusts dynamically based on player demand</li>
            </ul>
            <p>The current pricing mode for the round is displayed on the Breakme.ai website.</p>

            <h2>Incentive Pool (Round Bounty)</h2>
            <p>Each round's bounty is determined by the number of paid attempts, minus applicable fees. <strong>At least 70%</strong> of the attempt fees are allocated to the round bounty wallet, ensuring that the cost to attempt remains relatively low compared to the potential reward. The remaining fees are distributed between the adjustment agent and the development fee wallet.</p>

            <h2>Adjustment Agent</h2>
            <p>A predetermined percentage of attempt fees is routed to the <strong>adjustment agent's wallet</strong>. This AI-powered agent monitors the state of the $BREK market, focusing on metrics such as market cap/liquidity ratios and inflows/outflows.</p>
            <p>The adjustment agent has two primary mechanisms:</p>
            <ul>
              <li><strong>Buyback & Provide Liquidity:</strong> The agent purchases $BREK tokens on the open market and pairs them with SOL or USDC to add liquidity to a pool. It actively manages pool positions, harvests fees, and reinvests them based on market insights.</li>
              <li><strong>Buyback & Burn:</strong> The agent purchases $BREK tokens and burns them, permanently reducing the token supply.</li>
            </ul>

            <h2>Development Fee Wallet</h2>
            <p>A predetermined percentage of attempt fees is allocated to the development fee wallet. These funds support ongoing product development, including <em>tools, integrations, marketing, partnerships, and kickstarting new rounds</em>.</p>

            <h2>Future Roadmap</h2>
            <h3>Product Expansion</h3>
            <ul>
              <li><strong>Enhanced Agent Personality:</strong> Adding support for diverse agent personalities</li>
              <li><strong>Deepseek AI Integration:</strong> Integrating advanced AI capabilities</li>
              <li><strong>Marketing Partnerships:</strong> Collaborating with communities for promotional rounds</li>
              <li><strong>Custom LLM:</strong> Developing an in-house trained large language model</li>
              <li><strong>Web-Based Platform:</strong> Expanding to enable more gamification</li>
              <li><strong>Pen-Testing Services:</strong> Adapting for companies to test their LLMs</li>
              <li><strong>Custom Scenarios:</strong> Standardizing the agent framework</li>
              <li><strong>User Tiers:</strong> Establishing player tiers based on metrics</li>
              <li><strong>Payment Integration:</strong> Introducing token-only payments</li>
            </ul>

            <h2>Conclusion</h2>
            <p>Breakme.ai aims to create a <strong>sustainable and engaging platform</strong> for crowdsourced AI penetration testing. By combining <em>gamification, blockchain technology, and AI</em>, the project seeks to improve the robustness of large language models while offering players a unique and rewarding experience.</p>
          </div>

          <div className="legal-disclaimer">
            <p>DISCLAIMER: The development team reserves all rights to modify, amend, remove, or discontinue any aspect of the platform, features, or functionalities described above at any time and at its sole discretion, without prior notice. Nothing contained herein constitutes financial advice, a solicitation, recommendation, endorsement, or offer to purchase or sell any financial instruments or to participate in any particular trading strategy. All information is provided on an as-is basis for informational purposes only.</p>
          </div>

          {/* Footer Navigation */}
          <div className="page-footer">
            <div className="legal-links">
              <Link to="/disclaimer">Disclaimer</Link>
              <span className="separator">|</span>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms-of-use">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 